<template>
  <v-content v-if="loading">
    <v-flex class="photo-group">
      <v-carousel class="carousel"
                  :show-arrows="false"
                  cycle="true"
                  interval="5000">
        <v-carousel-item v-for="(item,i) in items"
                         :key="i"
                         :src="item.src"
                         reverse-transition="fade-transition"
                         transition="fade-transition"
                         continuous="true">
          <v-flex class="carousel-text"
                  :style="'color:'+item.color">
            <h1>{{item.title}}</h1>
            <h3>{{item.text}}</h3>
          </v-flex>
        </v-carousel-item>
      </v-carousel>

       <!-- <v-flex class="main-title">
        <h1>四川持恒测绘工程监理有限责任公司</h1>
        <v-flex class="main-title-text"></v-flex>
        <v-row style="margin: 50px 0 0 0;">
          <v-btn class="btn-first"
                 @click="$router.push({ name: 'CompanyProfile' })">了解更多</v-btn>
          <v-flex class="or center-style">还是</v-flex>
          <v-btn @click="doContact"
                 class="btn-first">马上联系</v-btn>
        </v-row>
      </v-flex> -->
    </v-flex>

    <!-- 我们的服务优势 -->
    <v-flex>
      <v-flex class="center-style about-product-title">我们的服务优势</v-flex>

      <v-row class="center-style rows">
        <v-flex v-for="(item,i) in productItems"
                :key="'0'+i"
                class="about-product-content">
          <v-flex class="about-product-content-title">{{item.type}}</v-flex>
          <v-flex class="about-product-number">{{'0'+(i+1)}}</v-flex>
          <h3>{{item.title}}</h3>
          <v-divider class="product-divider"></v-divider>
          <v-flex class="about-product-content-text">{{item.text}}</v-flex>
        </v-flex>
      </v-row>

      <!-- 我们的服务 -->
      <v-flex class="center-style product-technology">
        <v-row class="rows center-style">
          <v-flex class="product-technology-content"
                  v-for="(item,i) in technologyItems"
                  :key="'1'+i">
            <v-icon class="product-technology-icon">{{item.icon}}</v-icon>
            <v-flex class="font-white product-technology-title">{{item.title}}</v-flex>
            <v-flex class="center-style">
              <v-divider class="product-divider"></v-divider>
            </v-flex>
            <v-flex class="font-white product-technology-text">{{item.text}}</v-flex>
          </v-flex>
        </v-row>
      </v-flex>
    </v-flex>

    <!-- 公司文化 -->
     <v-row class="center-style company-culture">
        <v-flex class="center-style product-technology-2">
        <v-row class="rows center-style">
          <v-flex class="product-technology-content"
                  v-for="(item,i) in ywItems"
                  :key="'1'+i">
            <v-icon class="product-technology-icon">{{item.icon}}</v-icon>
            <v-flex class="font-black product-technology-title">{{item.title}}</v-flex>
            <v-flex class="center-style">
              <v-divider class="product-divider"></v-divider>
            </v-flex>
            <v-flex class="font-black product-technology-text">{{item.text}}</v-flex>
          </v-flex>
        </v-row>
      </v-flex>
      <!--<v-flex class="culture-title">
        <v-row class="company-title-conent"
               v-for="(item,i) in companyCulture"
               :key="'2'+i"
               @mouseover="updateCulture(item.value)">
          <v-flex class="center-style company-title-divider">
            <transition name="slide-fade">
              <v-divider vertical
                         v-if="cultureIndex == item.value"
                         style=" border: 2px solid #42a5f6 !important;"></v-divider>
            </transition>
          </v-flex>

          <v-flex style="flex:none;">
            <v-flex class="culture-conent-title"
                    :class="{'culture-selected':cultureIndex == item.value}">{{item.text}}</v-flex>
            <v-icon v-show="cultureIndex == item.value"
                    class="culture-conent-icon">fa fa-arrow-right</v-icon>
          </v-flex>
        </v-row>
      </v-flex>
      <v-flex class="company-culture-conent">
        <v-row class="image-top">
          <v-flex class="image center-style"
                  :style=" {background:'url('+ cultureItem.src1 +')'}">
            <v-alert class="alter center-style">{{cultureItem.text1}}</v-alert>
           
          </v-flex>
          <v-flex class="image center-style"
                  :style=" {background:'url('+ cultureItem.src2 +')'}">
            <v-alert class="alter center-style">{{cultureItem.text2}}</v-alert>
           
          </v-flex>
        </v-row>
        <v-row style="height: 50%;flex: none;">
          <v-flex class="image2 center-style"
                  :style=" {background:'url('+ cultureItem.src3 +')'}">
            <v-alert class="alter center-style">{{cultureItem.text3}}</v-alert>
          
          </v-flex> 
        </v-row>
      </v-flex>-->
    </v-row>
  </v-content>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      cultureIndex: 0,
      cultureItem: {},
      items: [
        {
          src: require('@/images/carousel/text1.jpg'),
          title: '精准测绘',

          color: 'white',
        },
        {
          src: require('@/images/carousel/text2.jpg'),
          title: '无人机航拍',

          color: 'white',
        },
        {
          src: require('@/images/carousel/text3.jpg'),
          title: '信息平台',

          color: 'white',
        },
        {
          src: require('@/images/carousel/text4.jpg'),
          title: '实施监督',

          color: 'white',
        },
      ],
      productItems: [
        {
          title: '服务理念',
          text:
            '技术是基础，服务是关键  ',
        },
        {
          title: '品质保障',
          text:
            '专业决定价值，品质成就未来',
        },
        {
          title: '价格理念',
          text:
            '术业有专攻，制物超所值',
        },
      ],
      technologyItems: [
        {
          icon: 'fa fa-camera',
          title: '精准测绘',
          text:
            '        土地测绘是指使用以计算机技术、光电技术、网络通讯技术、空间科学、信息科学为基础，以全球定位系统(GPS)、遥感(RS)、地理信息系统(GIS)为技术核心，将地面已有的特征点和界线，通过测量手段获得反映地面现状的图形和位子信息，供工程建设的规划设计和行政管理之用',
        },
        {
          icon: 'fa fa-camera',
          title: '无人机航拍',
          text:
            '        以无人机作为空中平台，以机载遥感设备获取信息，用计算机对图像信息进行搜集处理，并按照一定精度要求制作正射及倾斜图像，并可利用BIM建模软件进行项目设计。',
        },
       
      ],
      ywItems:[
        {
          icon: 'fa fa-camera',
          title: '空间规划',
          text:
            '        国土空间基础信息平台的建设是落实国土空间规划编制的核心支撑，是建立健全国土空间规划动态监测评估预警和实施监管机制的重要基础。平台要为自然资源业务提供底板支撑，支持数据的互通互通，资源共享，为国土空间规划编制、审批、实施、监管等提供全面的数据支撑和统一的平台支持。',
        },
        {
          icon: 'fa fa-camera',
          title: '实施监督',
          text:
            '        国土空间规划“一张图”实施监督信息系统覆盖国土空间规划全生命周期，强调对国土空间规划与实施进行监督和预警，通过构建监测评估预警数据资源体系编目、指标体系、模型体系和标准库，打通数据通道，实现智能化的动态监测、周期体检、专项评估及及时预警，实现对国土空间规划和实施落地的一站式管理。',
        },
      ],
      companyCulture: [
        { value: 0, text: '企业理念' },
        { value: 1, text: '企业价值观' },
        { value: 2, text: '企业准则' },
      ],
      cultureItems: [
        //企业理念 company philosophy
        {
          value: 0,
          src1: require('@/images/companyCulture/companyPhilosophy/philosophy1.jpg'),
          src2: require('@/images/companyCulture/companyPhilosophy/philosophy2.jpg'),
          src3: require('@/images/companyCulture/companyPhilosophy/philosophy3.jpg'),
          text1: '诚信为本',
          text2: '创新为志',
          text3: '服务为源',
        },
        //企业价值观 corporate values
        {
          value: 1,
          src1: require('@/images/companyCulture/corporateValues/values1.jpg'),
          src2: require('@/images/companyCulture/corporateValues/values2.jpg'),
          src3: require('@/images/companyCulture/corporateValues/values3.jpg'),
          text1: '以人为本',
          text2: '尊重知识',
          text3: '重视人才',
        },
        //企业准则 company rules
        {
          value: 2,
          src1: require('@/images/companyCulture/companyRules/rules1.jpg'),
          src2: require('@/images/companyCulture/companyRules/rules2.jpg'),
          src3: require('@/images/companyCulture/companyRules/rules3.jpg'),
          text1: '踏实敬业',
          text2: '开拓进取',
          text3: '专业高效',
        },
      ],
    }
  },
  created () {
    this.init()
  },
  methods: {
    //初期化
    init () {
      this.cultureItem = this.cultureItems[0];
      this.loading = true;
    },
    updateCulture (val) {
      this.cultureIndex = val;
      this.cultureItem = this.cultureItems[val];
    },
    //滚动到底部
    doContact () {
      this.$emit('doContact')
    },
    getUserIP (onNewIP) {
      let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
      let pc = new MyPeerConnection({
        iceServers: []
      });
      let noop = () => {
      };
      let localIPs = {};
      let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
      let iterateIP = (ip) => {
        if (!localIPs[ip]) onNewIP(ip);
        localIPs[ip] = true;
      };
      pc.createDataChannel('');
      pc.createOffer().then((sdp) => {
        sdp.sdp.split('\n').forEach(function (line) {
          if (line.indexOf('candidate') < 0) return;
          line.match(ipRegex).forEach(iterateIP);
        });
        pc.setLocalDescription(sdp, noop, noop);
      }).catch(() => {

      });
      pc.onicecandidate = (ice) => {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    }
  },
}
</script>

<style scoped>
.center-style {
  display: flex;
  justify-content: center;
  align-items: center;
}
.carousel,
.carousel >>> .v-image {
  height: 400px !important;
  position: relative;
}
.carousel-text {
  position: absolute;
  right: 200px;
  top: 150px;
}
.main-title {
  position: absolute;
  left: 100px;
  top: 200px;
  color: antiquewhite;
}
.main-title-text {
  max-width: 800px;
  margin-left: 50px;
}
.btn-first {
  background: #42a5f6 !important;
  width: 150px;
  height: 40px !important;
  color: white;
  font-size: 20px;
  font-weight: bold;
}
.or {
  font-size: 20px;
  width: 100px;
  flex: none;
}
.about-product-title {
  font-size: 30px;
  font-weight: bold;
  margin-top: 10px;
}
.rows {
  margin: 15px 0 0 0;
}
.about-product-content {
  width: 33.3%;
  height: 300px;
  flex: none;
  padding: 10px 20px 20px 30px;
  position: relative;
  max-width: 375px;
  min-width: 260px;
  overflow: hidden;
}
.about-product-content-title {
  color: #9e9e9e;
  margin-bottom: 7px;
}
.product-divider {
  max-width: 30px;
  border: 2px solid #42a5f6 !important;
  margin: 3px 0 20px 0;
}
.about-product-content-text {
  width: 60%;
  flex: none;
  font-size: 15px;
  color: gray;
}
.about-product-number {
  width: 100px;
  height: 100px;
  font-size: 70px;
  color: #f5f5f5;
  position: absolute;
  right: 50px;
  font-weight: bolder;
  top: -15px;
}
.product-technology {
  background: #050b1f;
}
.product-technology-2 {
  background: white;
}
.product-technology-content {
  min-width: 110px;
  max-width: 500px;
  padding: 12px 90px 12px 90px;
  height: 300px;
  text-align: center;
  align-items: center;
}
.font-white {
  color: white;
}
.font-black {
  color: black;
}
.product-technology-icon {
  color: #42a5f6;
  font-size: 30px;
}
.product-technology-title {
  font-size: 25px;
  margin: 10px 0 10px 0;
}
.product-technology-text {
  white-space: pre-wrap;
  font-size: 13px;
  text-align: left;
}
.company-culture {
  margin: 0;
}
.culture-title {
  width: 27%;
  flex: none;
}
.company-title-conent {
  height: 250px;
  align-content: center;
}
.culture-conent-title {
  font-size: 25px;
  margin-bottom: 10px;
  white-space: initial;
  color: gray;
}
.culture-selected {
  font-size: 30px !important;
  color: black;
}
.company-title-divider {
  width: 20px !important;
  flex: none;
  height: 80px;
  margin: 0 20px 0 20px;
}
.company-culture-conent {
  width: 40%;
  height: 750px;
  flex: none;
}
.image-top {
  height: 50%;
  flex: none;
}
.image {
  position: relative;
  width: 50%;
  flex: none;
  background-position: center center !important;
}
.image2 {
  position: relative;
  width: 100%;
  height: 100%;
  flex: none;
  background-position: center center !important;
}
.image img,
.image2 img {
  width: 100%;
  height: 100%;
}
.alter {
  width: 170px;
  height: 80px;
  background: transparent;
  font-size: 30px;
  color: #f5f5f5;
  position: absolute;
  bottom: 20px;
  overflow: hidden;
  white-space: initial;
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>